import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Button from "../components/Button";
import colors from "../styles/colors";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen text-center px-4"
      style={{ backgroundColor: colors.darkBrown }}
    >
      <motion.h1
        className="text-6xl font-bold text-red-500 mb-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {t("notFound.title")}
      </motion.h1>
      <motion.p
        className="text-xl text-gray-100 mb-6"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {t("notFound.message")}
      </motion.p>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <Button to={"/"} text={t("notFound.button")} />
      </motion.div>
    </div>
  );
};

export default NotFound;
